<template>
  <div class="form-group">
    <label :class="{ error: Boolean(errors.first(name)) }">{{ title }}</label>
    <div class="start-enhancer">
      <slot name="startEnhancer" />
    </div>
    <input 
      v-validate="validate"
      :class="{ error: Boolean(errors.first(name)) }"
      v-bind="$attrs"
      :validate="validate.length ? true: false"
      :value="value"
      :name="name"
      :type="inputType"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('enter')"
    >
    <div class="end-enhancer">
      <div v-if="type === 'password'" class="end-enhancer-password" @click="() => hidden = !hidden">
        <EyeIcon v-if="!hidden" :size="20" />
        <EyeOffIcon v-if="hidden" :size="20" />
      </div>
      <slot v-if="type !== 'password'" name="endEnhancer" />
    </div>
  </div>
</template>

<script>
import EyeIcon from '@/components/base/icons/eye.vue'
import EyeOffIcon from '@/components/base/icons/eye-off.vue'

export default {
  components: {
    EyeIcon,
    EyeOffIcon
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true
    },
    validate: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [Number, String],
      required: false,
      default: ''
    },
    type: { type: String, required: false, default: 'text' }
  },
  data: () => ({ hidden: true }),
  computed: {
    inputType() {
      if (this.type === 'password') {
        return this.hidden ? 'password' : 'text'
      }
      return this.type
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.form-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: $scale100;
  width: 100%;

  label {
    @include LabelXSmall;
    font-family: $monserratFontFamily;
    color: $neutral400;

    &.error {
      color: $negative400;
    }
  }

  .start-enhancer {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    padding: 28px 16px 17px;
    display: flex;
    align-items: center;
    color: $neutral400;
  }

  .end-enhancer-password {
    cursor: pointer;
  }

  .start-enhancer + input {
    padding-left: 46px;
  }

  .end-enhancer {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    padding: 28px 16px 17px;
    display: flex;
    align-items: center;
    color: $neutral400;
  }

  .end-enhancer + input {
    padding-right: 46px;
  }

  input,
  textarea,
  select {
    width: 100%;
    background: $neutral100;

    border: 1px solid $darkBlue100;
    border-radius: 8px;

    @include ParagraphSmall;
    font-family: $monserratFontFamily;
    color: $neutral500;

    padding: 15px 16px;

    &.error {
      border-color: $negative100;
    }
  }

  input:not([disabled]):hover,
  input:not([disabled]):hover,
  textarea:not([disabled]):hover,
  textarea:not([disabled]):hover,
  select:not([disabled]):hover,
  select:not([disabled]):hover {
    border-color: $neutral400;
    outline: none;

    &.error {
      border-color: $negative200;
    }
  }

  input:not([readonly]):focus,
  input:not([readonly]):focus,
  textarea:not([readonly]):focus,
  textarea:not([readonly]):focus,
  select:not([readonly]):focus,
  select:not([readonly]):focus {
    border-color: $blue300;
    outline: none;

    &.error {
      border-color: $negative400;
    }
  }
}
</style>
